import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../../../api";
import urls from "../../../../urls";
import { COMPONENT_QUERY_KEY } from "../../../../utils/constants";
import { ObjectName } from "../../../../utils/enums";

export function useAnlagenStromstgMutation(
  anlageStromstgId: number,
  siteId: number
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (generatorIds: Array<number>) =>
      mutateAnlagenStromstg(anlageStromstgId, generatorIds),
    onSuccess() {
      const objectCacheName = COMPONENT_QUERY_KEY[ObjectName.Generator];

      queryClient.invalidateQueries({
        queryKey: ["anlagenStromstgListGenerators", anlageStromstgId]
      });

      queryClient.invalidateQueries({
        queryKey: [objectCacheName, { siteOrVariantId: siteId }]
      });

      return queryClient.invalidateQueries({
        queryKey: ["generatorSingleEndpoint", { siteId }]
      });
    }
  });
}

function mutateAnlagenStromstg(
  anlageStromstg: number,
  generatorIds: Array<number>
) {
  return api.post(urls.api.anlageStromstgSetGenerators(anlageStromstg), {
    generators: generatorIds
  });
}
